import { lend, student } from "../client";
const config = {
  headers: {},
  signal: null,
};

export const addLendBooks = (params) => {
  const user = {
    flag: "addLibraryBookLending",
    parameters: {
      libraryBookLending: params,
    },
  };
  return lend.post("/library/lend/books", user);
};

export const addBookReturns = (params) => {
  const user = {
    flag: "updateLibraryBookLending",
    parameters: {
      libraryBookLending: params,
    },
  };
  return lend.post("/library/return/books", user);
};

export const getBooksList = (params) => {
  const user = {
    flag: "getBookReturn",
    parameters: {
      bookReturn: {
        regNumber: params.regNumber,
        limit: params.limit,
        offset: params.offset,
      },
    },
  };

  return lend.post("/library/get/return/books", user);
};

export const getBooksTitle = (params) => {
  const user = {
    flag: "bookSearch",
    parameters: {
      bookSearch: {
        title: params.title,
        institutionId:params.institutionId
        
      },
    },
  };
  return lend.post("/library/search/books", user);
};

export const searchStudentId = (params) => {
  config.signal = params.signal;
  const user = {
    flag: "studentSearch",
    parameters: {
      studentSearch: {
        regNumber: params,
        sortBy: "created_at",
        orderBy: "asc",
        limit: 100,
        offset: 0,

      },
    },
  };
  return student.post("/student/search", user);
};

export const getStudentId = (params) => {
  console.log(params, 'retrytuy');
  const user = {
    flag: "studentSearch",
    parameters: {
      studentSearch: {
        regNumber: params.value,
        sortBy: "created_at",
        orderBy: "asc",
        limit: 100,
        offset: 0,
        institutionId: params.institutionId

        // institutionId:params.institutionId

      },
    },
  };
  return student.post("/student/search", user);
};
